import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TitleData } from '../model/title-data';
@Injectable({
    providedIn: 'root',
})
export class SelectedTitleService {
    private refreshDataSub = new Subject<boolean>();
    refreshDataObservable = this.refreshDataSub.asObservable();
    titleData = null;
    private sourceTitle = new BehaviorSubject<TitleData>(this.titleData);
    dataTitle$ = this.sourceTitle.asObservable();

    public saveData(data: TitleData) {
        this.titleData = data;
        this.sourceTitle.next(this.titleData);
    }

    public clearData() {
        this.titleData= null;
        this.sourceTitle.next(null);
    }

    public refreshData(e) {
        this.refreshDataSub.next(e);
    }
}
